import { Fragment, useState } from "react";
import config from "../configuration/config";

/**
 * SparepartsCategoryBox Component
 * Compact category card used in the search page grid.
 * Styled via: src/pages/parts/css/sparepartsCategoryBox.css
 */
export function SparepartsCategoryBox({
  key = null,
  link,
  img,
  imgUrl = "",
  titleEn = " ",
  titleAr = " ",
}) {
  const [lang] = useState(localStorage.getItem("i18nextLng"));
  const titel = lang === "en" ? titleEn : titleAr;

  const fallbackImg =
    lang === "ar"
      ? "/assets/images/parts/PARTS_TOYOTA-AR-no-img.png"
      : "/assets/images/parts/PARTS_TOYOTA-EN-no-img.png";

  let imageSrc = fallbackImg;
  if (imgUrl && imgUrl !== "null" && imgUrl !== "") {
    imageSrc = config.controllURL + imgUrl;
  } else if (img && img !== "null") {
    imageSrc = "data:image/png;base64," + img;
  }

  return (
    <Fragment key={key}>
      <a
        href={link ?? "#"}
        className="pt-cat-card"
        onClick={(e) => {
          if (!link) e.preventDefault();
        }}
      >
        {/* 1. Image Area — CSS handles hover zoom and red overlay */}
        <div className="pt-cat-card__img-wrap">
          <img
            src={imageSrc}
            alt={titel}
            className="pt-cat-card__img"
            loading="lazy"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = fallbackImg;
            }}
          />
        </div>

        {/* 2. Title Area — font size handled in typography.css */}
        <h3 className="pt-cat-card__title">{titel}</h3>
      </a>
    </Fragment>
  );
}
